<template>
  <div  style="margin:10px;width:100%">
    <div class="flex" @click="handleClick">
      <div class="box grow flex column justify-center info" v-if="!flip">
        <span style="margin-bottom:10px;">
          <i v-if="!qtyValid" class="mdi mdi-alert">&nbsp;</i>{{customerName}}
        </span>
        <span class="fs-14 secondary-text" style="margin-left:5px;margin-bottom:3px;">
          <span>{{quantityAvailable}} x </span>
          {{productName}}
        </span>
        <span class="fs-14 secondary-text ml-5 mb-3" v-if="providerName">{{providerName}}</span>
        <UnitFormatVolumeLabel
          class="ml-5 mb-3"
          :unit="reservation.product.unit"
          :uvc="reservation.product.uvc"
          :format="reservation.product.format"
          :volume="reservation.product.volume" />
        <span class="fs-14 secondary-text ml-5 mb-3">{{inventoryName}}</span>
        <span v-if="showSalesRep" class="fs-14 secondary-text ml-5 mb-3">{{salesRepName}}</span>
      </div>
      <div class="overdue flex pr-5" style="flex-direction:column" v-if="!flip">
        <span class="" style="text-align:right;">{{moment(date)}}</span>
        <div>
          <div style="text-align:right;" v-if="!reservation.delayed && !reservation.intent && !reservation.completed && showDelayIndicator">
            <span class="fs-14 secondary-text" v-if="nbDays==0">{{$t('reservation.today')}}</span><span v-else class="fs-14 secondary-text">{{nbDays}} {{ $t('reservation.days') }}</span><status-indicator class="ml-10" :negative="isNegative(nbDays)" :intermediary="isIntermediary(nbDays)" :positive="isPositive(nbDays)" pulse/>
          </div>
          <div  style="text-align:right;" v-if="reservation.delayed">
            <span class="fs-14 secondary-text" >{{ $t('reservation.toCome') }}</span>
          </div>
          <div  style="text-align:right;" v-if="reservation.intent">
            <span class="fs-14 secondary-text" >{{ $t('reservation.intent') }}</span>
          </div>
        </div>
        <div v-if="reservation.completed">
          <div v-if="reservation.expired" style="text-align:right;">
            <el-tag type="danger" size="small" style="margin-top:5px;">{{$t("reservations.statuses.expired")}}</el-tag>
          </div>
          <div v-else style="text-align:right;">
            <el-tag type="danger" size="small" style="margin-top:5px;">{{$t("reservations.statuses.completed")}}</el-tag>
          </div>
        </div>
      </div>
    </div>
    <div v-if="flip" style="height:100px;text-align:center;" class="box grow flex column justify-center info animated fadeInRight" >
      <el-row type="flex" class="row-bg" justify="center">
        <el-col>
          <el-button @click="handleClick" type="text" icon="el-icon-arrow-left" style="position:absolute;left:0px;float:left;margin-right:30px;font-size:24px;"></el-button>
          <el-button-group style="text-align:center;">
           <el-button type="primary" icon="el-icon-edit"  @click="$emit('edit');handleClick()"></el-button>
           <!-- <el-button type="primary" icon="el-icon-check" @click="$emit('confirm')"></el-button> -->
           <el-button type="primary" icon="el-icon-delete" @click="$emit('delete')"></el-button>
         </el-button-group>
       </el-col>
     </el-row>
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import CustomerUtil from '@/utils/customer-util'
import ReservationUtil from '@/utils/reservation-util'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel';
export default {
  name: 'ReservationTile',
	props: {
    ctrlFlipBoard : { //Permet sur le mobile de cliquer sur la réservation et de voir les controles
      type : Boolean,
      default : false
    },
    reservation: {
      type: Object,
      require: true,
      default: null,
    },
    showSalesRep : {
      type : Boolean,
      default : false
    },
	},
  data() {
    return {
      flip : false
    };
  },components: {
    UnitFormatVolumeLabel,
  },
	methods: {
    handleClick(){
      if(this.ctrlFlipBoard){
        this.flip=!this.flip;
      }else{
        this.$emit('click');
      }

    },
    moment(datetime, format){
      return  moment(datetime).format('L');
    }
	},
	computed: {
    showDelayIndicator() {
      let show = true;

      if (this.reservation.intent === false && this.reservation.delayed === false && this.reservation.quantity.qty_available <= 0) {
        show = false;
      }
      return show;
    },
    qtyValid () {
      return ReservationUtil.isQuantityValid(this.reservation);
    },
    nbDays () {
      return this.reservation.nb_days;
    },
    date () {
      return this.reservation.created_at;
    },
    salesRepName () {
      return `${_.get(this.reservation, 'sales_rep.first_name')} ${_.get(this.reservation, 'sales_rep.last_name')}`
    },
    inventoryName () {
      return _.get(this.reservation, 'inventory.name');
    },
    productName () {
      return _.get(this.reservation, 'product.name');
    },
    customerName(){
      const customer = _.get(this.reservation, 'customer');
      if (customer == null ) return null;
      return CustomerUtil.customerName(customer.name, customer.usual_name);
    },
    providerName(){
      const provider = _.get(this.reservation, 'product.provider');
      if (provider == null ) return null;
      return CustomerUtil.customerName(provider.name, provider.usual_name);
    },
    quantityAvailable () {
      const quantity = _.get(this.reservation, 'quantity')
      if (quantity == null) return 0;
      return quantity.qty_reserved - quantity.qty_used;
    },
    ...mapGetters('reservations',['isPositive','isNegative','isIntermediary'])
	}
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.item-list {
  //margin: 0 auto;
  width: 100%;
  padding: 0px 30px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}

</style>
